<template src="../templates/usersTableRow.html">

</template>

<script>
    export default {
        name: "UsersTableRow",
        props: {
            contactModel: {
                type: Object,
                required: true,
            }, availableGroups: {
                type: Array,
                required: true,
            },
            isAdmin: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                addedGroups: [],
                availableGroupsTemp: [],
                editGroupsVisible: false,
                editContactModel: {
                    name: "",
                    email: "",
                    suburb: "",
                    fax: ""
                }
            }
        },
        watch: {
            availableGroups(val) {
                this.availableGroupsTemp = val;
            }
        },
        methods: {
            showErrorMsg(errMsg) {
                this.$message.error(errMsg);
            },
            getAddedGroups() {
                let url = `${this.$localApiURL}groups/getAddedGroups/${this.contactModel.contactId}`;
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {
                    let data = res.data;
                    if (data != null && data.length > 0) {
                        for (let item in data) {
                            self.addedGroups.push(data[item].clientAccessGroupId);
                        }
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
            ,
            loadEditDialog() {
                this.editGroupsVisible = true;
            }
            ,
            addGroup() {
                let self = this;
                this.$http.post(`${this.$localApiURL}groups/addGroups`, {
                    token: localStorage.getItem("jwt"),
                    groups: this.addedGroups,
                    contact: this.editContactModel
                }).then(res => {
                    let result = res.data;
                    if (result.error === "true") {
                        this.showErrorMsg(result.errorMsg);
                    } else {
                        self.editGroupsVisible = false;
                    }
                    self.$emit("contactUpdated");
                });
            },
            cancelAddingGroup() {
                this.editGroupsVisible = false;
                this.addedGroups = [];
                this.getAddedGroups();
            },
            isEditable() {
                return this.isAdmin || (this.contactModel.contactId.toString() === localStorage.getItem("contactId"))
            }
        },
        created() {
            this.getAddedGroups();
            this.editContactModel.contactId = this.contactModel.contactId;
            this.editContactModel.address = this.contactModel.address;
            this.editContactModel.name = this.contactModel.name;
            this.editContactModel.email = this.contactModel.email;
            this.editContactModel.suburb = this.contactModel.suburb;
            this.editContactModel.fax = this.contactModel.fax;
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/UsersTableRow.vue